import {useLocation} from 'react-router-dom';

import {LocationService} from './use-entity-from-location.service';

/**
 * Хук для извлечения имени сущности и подраздела из текущего местоположения в приложении.
 *
 * Использует React Router для получения текущего URL и извлекает из него:
 * - Имя сущности (последний сегмент URL)
 * - Код подраздела (имя сущности с префиксом "app.")
 *
 * @returns Объект с извлеченными данными из URL
 * @returns entityName - Имя сущности, извлеченное из последнего сегмента URL
 * @returns subsection - Код подраздела в формате "app.{entityName}"
 */
export const useEntityFromLocation = () => {
    const currentLocation = useLocation<History>();

    return {
        entityName: LocationService.getEntityNameFromLocation(currentLocation),
        subsection: LocationService.getSubsectionFromLocation(currentLocation),
    };
};
